<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="grow flex flex-col justify-center items-center p-8">
    <div class="relative w-48 h-48 mb-6 flex items-center justify-center">
      <div class="absolute inset-0 bg-primary-500/20 dark:bg-primary-500/10 rounded-full blur-2xl opacity-40 dark:opacity-60"></div>

      <svg
        class="w-32 h-32 text-slate-300 dark:text-slate-700 relative z-10"
        viewBox="0 0 200 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          opacity="0.5"
          d="M140 100C140 116.569 126.569 130 110 130H90L60 150V130C43.4315 130 30 116.569 30 100V60C30 43.4315 43.4315 30 60 30H110C126.569 30 140 43.4315 140 60V100Z"
          stroke="currentColor"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M170 130C170 146.569 156.569 160 140 160H120L90 180V160C73.4315 160 60 146.569 60 130V90C60 73.4315 73.4315 60 90 60H140C156.569 60 170 73.4315 170 90V130Z"
          fill="var(--color-base, transparent)"
          stroke="currentColor"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M115 110C115 110 103.569 110 95 110C86.4315 110 80 103.569 80 95C80 86.4315 86.4315 80 95 80C103.569 80 110 86.4315 110 95V100C110 105 118 105 118 95C118 82.2974 107.703 72 95 72C82.2974 72 72 82.2974 72 95C72 107.703 82.2974 118 95 118"
          stroke="var(--color-primary-500)"
          stroke-width="4"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <h3 class="text-xl font-medium mb-2 text-center">{{ t('components.common.comment.noComment') }}</h3>
    <p class="text-center max-w-sm subtitle">
      {{ t('components.common.comment.tooltip', { signe: '@' }) }}
    </p>
  </div>
</template>
